import Vue from "vue";
import App from "./App.vue";
import "tw-elements";
import "@/assets/css/tailwind.css";
import router from "./router";
import VueMeta from "vue-meta";
import store from "./store";
import axios from "axios";
import "vue-easytable/libs/theme-default/index.css";
import VueEasytable from "vue-easytable";
import VeContextmenu from "vue-easytable";
import VCalendar from "v-calendar";
import { VePagination } from "vue-easytable";
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
import IdleVue from "idle-vue";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import config from "@/config/config";

import ElementUI, { InputNumber } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// Import language config from Element UI
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'


library.add(fas);
library.add(far);
library.add(fab);

// Use ElementUI with English language
locale.use(lang);

const eventsHub = new Vue();

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;
axios.defaults.baseURL = config.baseURL;
Vue.prototype.$ApiVersion = "v1";
// Set the decryption key on the Vue prototype
Vue.prototype.$decryptionKey = process.env.VUE_APP_DECRYPTION_KEY;
// Register the component
Vue.component("ve-popper", Popper);
Vue.component(InputNumber.name, InputNumber);

Vue.use(VueEasytable);
Vue.use(VeContextmenu);
Vue.use(FloatingVue);
Vue.use(VueMeta);

Vue.config.productionTip = false;

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 10 * 60 * 1000,
  store
});

// Handle app idleness using the event bus or Vuex actions
eventsHub.$on('idle', () => {
  store.commit('setIsAppIdle', true);
});

eventsHub.$on('active', () => {
  store.commit('setIsAppIdle', false);
});

Vue.use(VCalendar, {
  componentPrefix: "vc",
  locales: {
    "pt-PT": {
      firstDayOfWeek: 2,
      masks: {
        L: "DD/MM/YYYY",
      },
    },
  },
});

Vue.use(ElementUI);

Vue.use(VePagination, { locale });

// Cancel Token Request Interceptor
axios.interceptors.request.use(
  function (config) {


    // Generate cancel token source
    let source = axios.CancelToken.source();

    // Set cancel token on this request
    config.cancelToken = source.token;

    // Add to vuex to make cancellation available from anywhere
    store.commit("addCancelTokens", source);

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }


);

if (process.env.NODE_ENV === 'production') {
  console.log = function () { };
  console.warn = function () { };
  console.error = function () { };
  console.info = function () { };
  console.debug = function () { };
}

if (location.href.includes('dataposit/login')) {
  location.href = "/login"

  console.log(location.href)

}


new Vue({
  router, // Set the Vue Router instance
  store, // Set the Vuex store instance
  render: (h) => h(App,),
}).$mount("#app");
